import { trpc } from '../../lib/trpc';
import { FaRocket } from 'react-icons/fa6';
import { toast } from 'sonner';
import { ConfirmationModal } from '../helpers/ConfirmationModal';


interface PublishQuizModalProps {
  isOpen: boolean;
  onClose: () => void;
  quizId: string;
  quizNumber: number;
}

export function PublishQuizModal({ isOpen, onClose, quizId, quizNumber }: PublishQuizModalProps) {
  const utils = trpc.useUtils();

  const publishQuizMutation = trpc.admin.quiz.publishQuiz.useMutation({
    onSuccess: () => {
      utils.admin.quiz.getById.invalidate();
      utils.admin.quiz.getQuizzes.invalidate();
      onClose();
      toast.success('Module published successfully!');
    },
    onError: (error) => {
      toast.error(`Failed to publish module: ${error.message}`);
    },
  });

  const handlePublish = () => {
    publishQuizMutation.mutate({ id: quizId });
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handlePublish}
      title="Publish Module?"
      description="Once published, the  module will be available to all users. You can still edit it after publishing."
      confirmText="Publish"
      cancelText="Cancel"
      icon={
        <div className="w-20 h-20 rounded-full bg-brand/10 flex items-center justify-center">
          <FaRocket className="w-9 h-9 text-brand" />
        </div>
      }
      isLoading={publishQuizMutation.isPending}
      highlightBox={{
        text: `MODULE ${quizNumber}`,
      }}
      variant={'regular'}
    />
  );
}
